import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NovoAtendimento} from "../../models/novo-atendimento";
import {AtendimentoService} from "../../services/atendimento.service";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {CadastrosGeraisService} from "../../services/cadastros-gerais.service";
import {TipoDocumentoCliente} from "../../gerais/models/tipo-documento-cliente";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {PessoaService} from "../../services/pessoa.service";
import {Observable, of} from "rxjs";
import {ListaSolicitante} from "../../models/lista-solicitante";

@Component({
    selector: 'app-novo-atendimento',
    templateUrl: './novo.component.html',
    styleUrl: './novo.component.css',
    standalone: false
})
export class NovoComponent {
  @Input() isModal = false;
  @Output() atualizarLista = new EventEmitter();
  modalNovoAtendimento = false;
  loading = true;
  novoAtendimento = new NovoAtendimento();
  formCadastrar: FormGroup;
  listaTipoDocumento: TipoDocumentoCliente[];
  showModalCliente = false;
  itensSolicitantes: Observable<Array<{id: number, descricao: string}>>;
  clientes = new ListaSolicitante();
  clienteTipoDocumento = '';
  clienteDocumento = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '200px',
    placeholder: 'Digite a declaração inicial aqui...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(private atendimentoService: AtendimentoService,
              private formBuilder: FormBuilder,
              private router: Router,
              private geraisService: CadastrosGeraisService,
              private pessoaService: PessoaService,
              private toastr: ToastrService) {
    this.construirFormulario();
    this.listarTiposDocumentosCliente();
  }

  showModalNovoAtendimento(pessoaId?: number){
    this.modalNovoAtendimento = true;
    this.loading = false;
    if (pessoaId) {
      this.formCadastrar.controls['pessoaId'].setValue(pessoaId);
    }
  }

  fecharModal(){
    this.modalNovoAtendimento = false;
    this.formCadastrar.reset();
  }

  salvar(){
    if(this.formCadastrar.invalid){
      this.validarFormulario();
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.loading = true;
        this.preencherModelo();
        this.atendimentoService.adicionar(this.novoAtendimento).subscribe(
          (response) => {
            this.loading = false;
            if (response.sucesso) {
              this.toastr.success("Atendimento salvo com sucesso");
              if (this.isModal) {
                this.fecharModal();
                this.atualizarLista.emit();
              } else {
                this.router.navigateByUrl('/cadastro/atendimento');
              }
            } else {
              this.toastr.error("Erro ao salvar atendimento - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            this.loading = false;
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        );
      }
    });
  }

  voltar(){
    if (this.isModal) {
      this.fecharModal();
    } else {
      this.router.navigateByUrl('/cadastro/atendimento');
    }
  }

  modalCliente(){
    this.showModalCliente = true;
  }

  fecharModalCliente(){
    this.showModalCliente = false;
  }

  public selecionarCliente(event: any) {
    if (event) {
      const cliente = this.clientes.itens.find(x => x.id === event.id);
      if (cliente) {
        const tipoDoc = this.listaTipoDocumento?.find(x => x.id == cliente.tipoDocumento);
        this.clienteTipoDocumento = tipoDoc ? tipoDoc.descricao : '';
        this.clienteDocumento = cliente.documento;

        this.formCadastrar.patchValue({
          tipoDocumento: cliente.tipoDocumento,
          documento: cliente.documento,
          telefoneSolicitante: cliente.telefone
        });
      }
    } else {
      this.clienteTipoDocumento = '';
      this.clienteDocumento = '';
      this.formCadastrar.patchValue({
        tipoDocumento: null,
        documento: null,
        telefoneSolicitante: null
      });
    }
  }

  public listarClientes(){
    this.pessoaService.selecionarListaAtivos().subscribe(response => {
      if(response.sucesso){
        let lista: any[] = [];
        this.clientes = response.dados;
        for(let contador = 0; contador < response.dados.itens.length; contador++){
          let id = response.dados.itens[contador]?.id;
          let descricao = response.dados.itens[contador]?.nome;
          lista.push({id: id, descricao: descricao});
        }
        this.itensSolicitantes = this.getItens(lista);
      }
    }, error => {
      this.toastr.error('Erro ao listar solicitantes ' + error, 'Erro');
    });
  }

  getItens(lista: any) : Observable<any>{
    return  of(lista);
  }

  private validarFormulario(){
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private preencherModelo(){
    this.novoAtendimento.descricaoInicial = this.formCadastrar.controls['descricaoInicial'].value;
    this.novoAtendimento.telefoneSolicitante = this.formCadastrar.controls['telefoneSolicitante'].value;
    this.novoAtendimento.nomeSolicitante = this.formCadastrar.controls['nomeSolicitante'].value;
    this.novoAtendimento.descricao = this.formCadastrar.controls['descricao'].value;
    this.novoAtendimento.tipoGerado = this.formCadastrar.controls['tipoGerado'].value || null;
    this.novoAtendimento.documento = this.formCadastrar.controls['documento'].value;
    this.novoAtendimento.tipoDocumento = this.formCadastrar.controls['tipoDocumento'].value || null;
    this.novoAtendimento.pessoaId = this.formCadastrar.controls['pessoaId'].value || null;
  }

  private construirFormulario(){
    this.formCadastrar = this.formBuilder.group({
          descricaoInicial: [this.novoAtendimento.descricaoInicial, [Validators.required]],
          telefoneSolicitante: [this.novoAtendimento.telefoneSolicitante],
          nomeSolicitante: [this.novoAtendimento.nomeSolicitante],
          descricao: [this.novoAtendimento.descricao, [Validators.required]],
          documento: [this.novoAtendimento.documento],
          tipoDocumento: [this.novoAtendimento.tipoDocumento || null],
          tipoGerado: [this.novoAtendimento.tipoGerado || null],
          pessoaId: [this.novoAtendimento.pessoaId || null, [Validators.required]]
        });

    this.listarClientes();
    this.loading = false;
  }

  private listarTiposDocumentosCliente(){
    this.geraisService.selecionarListaTipoDocumentosCliente().subscribe(retorno => {
      if(retorno.sucesso){
          this.listaTipoDocumento = retorno.dados;
      }
    });

  }

}
